import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membership-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "membership-main page-main"
  }, [_c('div', {
    staticClass: "membership-imgs"
  }, [_c('div', {
    staticClass: "fan",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/mem-fan-img.png`)}) center/100% auto no-repeat`
    },
    on: {
      "click": () => _vm.$router.push('/fan')
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "vip",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/mem-vip-img.png`)}) center/100% auto no-repeat`
    },
    on: {
      "click": () => _vm.$router.push('/vip')
    }
  }, [_c('div', {
    staticClass: "vipinfo-main"
  }, [_c('div', {
    staticClass: "vipinfo__level"
  }, [_vm._v("VIP " + _vm._s(_vm.userInfo.vip_level))]), _c('div', {
    staticClass: "vipinfo-progress-box"
  }, [_c('div', {
    staticClass: "vipinfo-progress"
  }, [_c('div', {
    staticClass: "vipinfo-progress-bg",
    style: {
      '--w': '100%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })]), _c('div', {
    staticClass: "vipinfo-progress-main",
    style: {
      '--w': _vm.userInfo.total_out_diamond / _vm.settingInfo.levelConfig.vipLevels[_vm.userInfo.vip_level == 0 ? 0 : _vm.userInfo.vip_level].exp * 100 + '%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })])])]), _vm.userCardInfo ? _c('div', {
    staticClass: "vipinfo-list"
  }, [_c('div', {
    staticClass: "vipinfo-item"
  }, [_c('div', {
    staticClass: "vipinfo-item-main",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v("+" + _vm._s(_vm.userCardInfo.total_coin_addition ? _vm.fmt_pre(_vm.userCardInfo.total_coin_addition) : 0) + "%")]), _c('div', {
    staticClass: "vipinfo-item__title"
  }, [_vm._v("FanPoints Boost")])]), _c('div', {
    staticClass: "vipinfo-item"
  }, [_c('div', {
    staticClass: "vipinfo-item-main hour",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v(_vm._s(_vm.userCardInfo.total_ai_chat ? _vm.fmt_pre(_vm.userCardInfo.total_ai_chat) : 0)), _c('span', [_vm._v("/Day")])]), _c('div', {
    staticClass: "vipinfo-item__title"
  }, [_vm._v("AI Chat")])])]) : _vm._e()])]), _c('div', {
    staticClass: "token",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/mem-token-img.png`)}) center/100% auto no-repeat`
    }
  }, [_vm._m(1)])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "fan-main"
  }, [_c('div', {
    staticClass: "fan__title"
  }, [_vm._v("FAN RIGHTS CENTER")]), _c('div', {
    staticClass: "fan__sub"
  }, [_vm._v("Earn FanPoints to unlock exclusive rewards")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "token-main"
  }, [_c('div', {
    staticClass: "token__title"
  }, [_vm._v("Tokenomics")]), _c('div', {
    staticClass: "token__coming"
  }, [_vm._v("Coming soon")])]);
}];
export { render, staticRenderFns };